import { render } from "./changepassword.vue?vue&type=template&id=041823ab&scoped=true"
import script from "./changepassword.vue?vue&type=script&lang=js"
export * from "./changepassword.vue?vue&type=script&lang=js"

import "./changepassword.vue?vue&type=style&index=0&id=041823ab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-041823ab"

export default script